import React from 'react';
import { DeleteIcon } from '../icons/DeleteIcon';

const Key = ({
  value,
  backspace = false,
  clear = false,
  classKey = '',
  onClick,
}) => {
  const handleClick = () => {
    if (backspace) return onClick && onClick();
    if (clear) return onClick && onClick();
    onClick && onClick();
  };

  classKey = 'key' + ' ' + classKey;

  return (
    <div className={classKey} onClick={handleClick}>
      {backspace && <DeleteIcon color={'#fff'} size={'40px'} />}
      {!backspace && !clear && value}
      {clear && 'C'}
    </div>
  );
};

export default Key;
